import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import styles from './progress-bar.module.scss';
export var ProgressBarColor;
(function (ProgressBarColor) {
    ProgressBarColor[ProgressBarColor["GREEN"] = 0] = "GREEN";
    ProgressBarColor[ProgressBarColor["YELLOW"] = 1] = "YELLOW";
    ProgressBarColor[ProgressBarColor["RED"] = 2] = "RED";
    ProgressBarColor[ProgressBarColor["BLUE"] = 3] = "BLUE";
})(ProgressBarColor || (ProgressBarColor = {}));
export const ProgressBar = ({ start = 0, progress, progressUpdater = () => progress, updateMillis = 250, className = '', color = ProgressBarColor.GREEN, showProgressOnInitialStep = true, ...restProps }) => {
    const [percentVal, setPercentVal] = useState(start);
    useEffect(() => {
        // Using timeout to show animation
        const timer = setTimeout(() => {
            const newPercentVal = progressUpdater(percentVal);
            if (newPercentVal < 0) {
                setPercentVal(0);
            }
            else if (newPercentVal > 100) {
                setPercentVal(100);
            }
            else {
                setPercentVal(newPercentVal);
            }
        }, updateMillis);
        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [start, progress, percentVal]);
    return (React.createElement("div", { className: cx(className, styles.progressBar), ...restProps },
        React.createElement("div", { className: cx(styles.progressBarInner, {
                [styles.redBar]: color === ProgressBarColor.RED,
                [styles.yellowBar]: color === ProgressBarColor.YELLOW,
                [styles.greenBar]: color === ProgressBarColor.GREEN,
                [styles.blueBar]: color === ProgressBarColor.BLUE,
                [styles.hideProgressOnInitialStep]: !showProgressOnInitialStep,
            }), style: { width: `${percentVal}%` } })));
};
//# sourceMappingURL=progress-bar.js.map